import React, { useEffect, useState } from "react";
import MapChart from "../Map";
import Grid from "@mui/material/Grid";
import {
  Typography,
  Tooltip,
  InputLabel,
  ListItem,
  MenuItem,
  Select,
  Button,
} from "@mui/material";
import View from "../View/index.js";
import KPICard from "../KPICard/index.js";
import { makeStyles } from "@material-ui/core/styles";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import GraphViewSNO_DOM from "../GraphView/GraphViewSNO_DOM/index.js";
import GraphViewDO_DP from "../GraphView/GraphViewDO_DP/index.js";
import GraphViewFg_Salvage from "../GraphView/GraphViewFg_Salvage/index.js";
import GraphViewIOFPB from "../GraphView/GraphView_IOF_baseline/index.js";
import GraphView_Distribution_Planning from "../GraphView/GraphView_Distribution_Planning/index.js";
import GraphViewPOOS from "../GraphView/GraphViewPOOS/index.js";
import GraphViewCapacityPlanning from "../GraphView/GraphViewCapacityPlanning/index.js";
import DateRangeFilters from "../../Filters/DateRangeFilters/index.js";
import { connect, useDispatch, useSelector } from "react-redux";
import GraphViewFF from "../GraphView/GraphViewFF/index.js";
import GraphViewRR from "../GraphView/GraphViewRR/index.js";
import GraphViewIF_Overall from "../GraphView/GraphViewIF_Overall/index.js";
import { setGraphOrMapView } from "../../../store/Actions/index.js";
import GraphViewDetention from "../GraphView/GraphViewDetention/index.js";
import GraphView_NPS from "../GraphView/GraphView_NPS/index.js";
import GraphView_Service_Level_Prediction from "../GraphView/GraphView_SLP/index.js";
import GraphView_IOF from "../GraphView/GraphView_IOF/index.js";
import GraphView_ERM from "../GraphView/GraphView_ERM/index.js";
import GraphViewTM from "../GraphView/GraphViewTM/index.js";
import { Paper } from "@material-ui/core";
const useStyles = makeStyles((_theme) => ({
  container: {
    flexGrow: 1,
    padding: "0px !important",
  },
  paper: {
    padding: "20px",
    boxShadow:
      "5px 2px 4px 0px rgba(0, 0, 0, 0.10), 0px 4px 12px 0px rgba(0, 0, 0, 0.10) !important",
  },
  mapViewTitle: {
    padding: "20px",
    color: "#333 !important",
    fontFamily: "Poppins, sans-serif",
    fontSize: "14px !important",
    fontWeight: "600 !important",
    position: "absolute",
    zIndex: 1,
  },
  gridItem: {
    padding: "0px",
    position: "relative",
  },
  kpiCardContainer: {
    padding: "20px 0px",
  },
  centerDiv: {
    display: "flex",
    alignItems: "end",
    justifyContent: "end",
    flexWrap: "nowrap", // Prevent wrapping
  },
  select: {
    borderColor: "transparent",
    borderStyle: "none",
    height: "30px",
    width: "140px",
    borderRadius: "4px !important",
    background: "var(--Neutral-Colors-White, #FFF)",
    fontSize: "14px !important",
    color: "#404041 !important",
    "&.MuiOutlinedInput-root": {
      margin: "0px 5px",
    },
  },
}));
function TabsContent(props) {
  const [viewValue, setViewValue] = useState("Graph View");
  const {
    data,
    type,
    mapData,
    tabIndex,
    tabList,
    MapLoading,
    KPILoading,
    Module,
    graphViewTabList,
    handleViewPowerBi,
    dateRangeFilterChange,
    date,
    rapidResponseDates,
    DateRangeFilterForRapidResponseActions,
    dateRangeDIP,
    dateRangeCP,
    DateRangeFilterCPActions,
    DateRangeFilterDIPActions,
    DateRangeFilterDetentionActions,
    dateRangeDetention,
    dateRangeFGS,
    DateRangeFilterFGSAction,
  } = props;
  // const [selectedSavedFilter, setSelectedSavedFilter] = useState(null);
  const [selectedSavedFilter] = useState(null);
  const graphOrMapView = useSelector((state) => state?.filter?.graphOrMapView);
  const [currentTabCP, setCurrentTabCP] = useState("");
  const [dateType, setDateType] = useState("Original RDD");
  let path = window.location.pathname;
  const classes = useStyles();
  const dispatch = useDispatch();

  const startDate = new Date();

  const endDate = new Date(startDate);
  endDate.setMonth(endDate.getMonth() + 1);

  const formattedStartDate = startDate.toISOString().slice(0, 10);
  const formattedEndDate = endDate.toISOString().slice(0, 10);

  const handleChange = (value) => {
    setViewValue(value);
    if (type === "RR") {
      dispatch(setGraphOrMapView(value));
    }
  };
  useEffect(() => {
    if (graphOrMapView === "Map View" && type === "RR") {
      handleChange("Map View");
    }
  }, [graphOrMapView]);
  useEffect(() => {
    if (type === "DETENTION" && data?.latestDate) {
      const date = new Date(data.latestDate);
      const endDate = `${date.getFullYear()}-${String(
        date.getMonth() + 1,
      ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
      DateRangeFilterDetentionActions([dateRangeDetention[0], endDate]);
    }
  }, [type, data]);
  const getTooltipTitle = (item) => {
    switch (item) {
      case "SNO":
        return `From DOM & Transportation - <br />
                1. COF & cost of fulfillment from DOM <br />
                2. Cost per case from transportation - total cases shipped to customer/total cost incurred for shipping to customer <br />
                Sorted by bottom 5 DCs by COF. <br />
                Filters applicable: Start and End date, Network and DCs`;
      case "DOM":
        return `From DOM - <br />
                1. Number of diverts recommended from this DC <br />
                2. Savings achieved through diverts from this DC <br />
                3. COF achieved in this DC <br />
                Sorted by bottom 5 DCs by COF. <br />
                Filters applicable: Start and End date, Network and DCs`;
      case "Potential Out Of Stock":
        return `DC's with the Highest RPOOS Risk`;
      case "DETENTION":
        return "Top 5 Locations with a high detention spend";
      case "Service Level Prediction":
        return "DCs to focus on with the 5 highest actionable revenue.Provides information on # SKUs affected, Unconfirmed quantity, COF of confirmed orders.<br/>Filters applicable: Network, DC, PL3, CL6, SKUs, Sold to Customer, Date Range";
      case "FF":
        return "Lanes to focus on with highest freight opportunity for selected time range.";
      case "RR":
        return "DCs that are affected with an event in the selected time-period with information on the # of orders, # of days of shutdown, Diverts recommended, potential fines averted.";
      case "Distribution_Planning":
        return "Top DCs to focus on based on inventory value at risk in the selected time frame with information on the average Working Capital and Delivery COF at the DC in selected time frame.";
      case "Deployment Planning":
        return "Top DCs COF for the selected date frame. Provides information on the savings through STR rejections, payload for these DCs.";
      case "Deployment Optimization":
        return "5 DCs with the highest STRs recommended with build dates in the selected date window. Also provides information on the recommended TLs, past due STOs for that DC.";
      case "Capacity Planning":
        return "Top DCs by Short-Term utilization in the selected time range. Provides projected Long-term utilization for the same period based from the latest report covering the given time range.";
      case "FG Salvage":
        return "Top 5 DCs with highest salvage risk for the selected time period. With information on inventory on hand, savings potential.";
      default:
        return "This is additional information about the MAP";
    }
  };
  const handleDateType = (event) => {
    setDateType(event?.target?.value);
  };
  const handleDateForFGS = () => {
    DateRangeFilterFGSAction([formattedStartDate, formattedEndDate]);
  };

  return (
    <div className={classes.container}>
      <Grid item xs={12} md={12} className={classes.kpiCardContainer}>
        <KPICard
          position={"relative"}
          margin={"20px 30px"}
          loading={KPILoading}
          cardContent={data}
          Module={Module}
          handleViewPowerBi={handleViewPowerBi}
        />
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} md={12} className={classes.gridItem}>
          {viewValue === "Map View" && (
            <>
              <Typography
                className={classes.mapViewTitle}
                style={{ display: "flex", alignItems: "center" }}
              >
                {path === "/ff"
                  ? `Lane to focus on - ${
                      type ? "" : tabList?.[tabIndex]?.name || ""
                    }`
                  : `DCs to focus on - ${
                      type ? "" : tabList?.[tabIndex]?.name || ""
                    }`}
                <Tooltip
                  title={
                    <span
                      dangerouslySetInnerHTML={{
                        __html: getTooltipTitle(tabList?.[tabIndex]?.name),
                      }}
                    />
                  }
                  placement="top"
                >
                  <InfoOutlinedIcon
                    fontSize="small"
                    style={{
                      color: "blue",
                      marginLeft: "5px",
                      cursor: "pointer",
                    }}
                  />
                </Tooltip>
              </Typography>
            </>
          )}
          <div className={classes.centerDiv}>
            {type === "IOFPB" && (
              <div style={{ display: "flex", alignItems: "center" }}>
                <div>
                  <InputLabel id="date-label">Date Type</InputLabel>
                </div>
                <ListItem>
                  <Select
                    value={dateType}
                    onChange={handleDateType}
                    className={classes.select}
                    displayEmpty
                    inputProps={{ "aria-label": "Without label" }}
                    sx={classes.select}
                  >
                    <MenuItem value={"Original RDD"}>Original RDD</MenuItem>
                    <MenuItem value={"Change Date"}>Change Date</MenuItem>
                  </Select>
                </ListItem>
              </div>
            )}
            <div style={{ display: "flex" }}>
              {type === "FGS" && (
                <Button
                  style={{ marginRight: "4px", marginBottom: "5px" }}
                  onClick={handleDateForFGS}
                >
                  Reset Date
                </Button>
              )}
              <DateRangeFilters
                handleDateChange={(value) => {
                  if (type === "RR") {
                    DateRangeFilterForRapidResponseActions(value);
                  } else if (type === "CP") {
                    DateRangeFilterCPActions(value);
                  } else if (type === "DIP") {
                    DateRangeFilterDIPActions(value);
                  } else if (type === "DETENTION") {
                    DateRangeFilterDetentionActions(value);
                  } else if (type === "FGS") {
                    DateRangeFilterFGSAction(value);
                  } else {
                    dateRangeFilterChange(value);
                  }
                }}
                value={
                  type === "RR"
                    ? rapidResponseDates
                    : type === "CP"
                      ? dateRangeCP
                      : type === "DIP"
                        ? dateRangeDIP
                        : type === "DETENTION"
                          ? dateRangeDetention
                          : type === "FGS"
                            ? dateRangeFGS
                            : selectedSavedFilter
                              ? selectedSavedFilter.Date
                              : date
                }
                type={type === "ff" ? "ff" : type === "RR" ? "rr" : type}
              />
            </div>
          </div>
          <Paper elevation={0} className={classes.paper}>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginBottom: "18px",
              }}
            >
              {!["IOF", "IOFPB", "ERM", "NPS", "POOS"]?.includes(type) && (
                <View
                  viewValue={viewValue}
                  handleChange={handleChange}
                  tab={tabList[tabIndex]?.name}
                />
              )}
            </div>
            {viewValue === "Map View" ? (
              <MapChart
                chartData={mapData}
                cardContent={data}
                MapLoading={MapLoading}
                Module={Module}
              />
            ) : type === "DO" ? (
              <GraphViewDO_DP
                cardContent={data}
                KPILoading={KPILoading}
                Module={Module}
                graphViewTabList={graphViewTabList}
                handleViewPowerBi={handleViewPowerBi}
              />
            ) : type === "FGS" ? (
              <GraphViewFg_Salvage
                cardContent={data}
                KPILoading={KPILoading}
                Module={Module}
                graphViewTabList={graphViewTabList}
              />
            ) : type === "IOFPB" ? (
              <GraphViewIOFPB
                cardContent={data}
                KPILoading={KPILoading}
                Module={Module}
                graphViewTabList={graphViewTabList}
                dateType={dateType}
              />
            ) : type === "TM" ? (
              <GraphViewTM
                cardContent={data}
                KPILoading={KPILoading}
                Module={Module}
                graphViewTabList={graphViewTabList}
              />
            ) : type === "NPS" ? (
              <GraphView_NPS
                cardContent={data}
                KPILoading={KPILoading}
                Module={Module}
                graphViewTabList={graphViewTabList}
              />
            ) : type === "CP" ? (
              <GraphViewCapacityPlanning
                Module={Module}
                graphViewTabList={graphViewTabList}
                dateRangeFilterChange={dateRangeFilterChange}
                setCurrentTabCP={setCurrentTabCP}
                currentTabCP={currentTabCP}
              />
            ) : // <GraphViewCapacityPlanning Module={Module} graphViewTabList={graphViewTabList} dateRangeFilterChange={dateRangeFilterChange} />
            type === "DIP" ? (
              <GraphView_Distribution_Planning
                cardContent={data}
                KPILoading={KPILoading}
                Module={Module}
                graphViewTabList={graphViewTabList}
              />
            ) : type === "POOS" ? (
              <GraphViewPOOS
                cardContent={data}
                KPILoading={KPILoading}
                Module={Module}
                graphViewTabList={graphViewTabList}
              />
            ) : type === "ff" ? (
              <GraphViewFF
                cardContent={data}
                KPILoading={KPILoading}
                Module={Module}
                graphViewTabList={graphViewTabList}
              />
            ) : type === "RR" ? (
              <GraphViewRR
                cardContent={data}
                KPILoading={KPILoading}
                Module={Module}
                graphViewTabList={graphViewTabList}
              />
            ) : type === "IF" ? (
              <GraphViewIF_Overall
                cardContent={data}
                KPILoading={KPILoading}
                Module={Module}
                graphViewTabList={graphViewTabList}
              />
            ) : type === "DETENTION" ? (
              <GraphViewDetention
                cardContent={data}
                KPILoading={KPILoading}
                Module={Module}
                graphViewTabList={graphViewTabList}
              />
            ) : type === "SLP" ? (
              <GraphView_Service_Level_Prediction
                cardContent={data}
                KPILoading={KPILoading}
                Module={Module}
                graphViewTabList={graphViewTabList}
              />
            ) : type === "IOF" ? (
              <GraphView_IOF
                cardContent={data}
                KPILoading={KPILoading}
                Module={Module}
                graphViewTabList={graphViewTabList}
              />
            ) : type === "ERM" ? (
              <GraphView_ERM
                cardContent={data}
                KPILoading={KPILoading}
                Module={Module}
                graphViewTabList={graphViewTabList}
              />
            ) : (
              <GraphViewSNO_DOM
                cardContent={data}
                KPILoading={KPILoading}
                Module={Module}
                graphViewTabList={graphViewTabList}
              />
            )}
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
}
const mapStateToProps = (state) => ({
  date: state.filter.Date,
  rapidResponseDates: state.filter.rapidResponseDates,
  dateRangeDIP: state.filter.dateRangeDIP,
  dateRangeCP: state.filter.dateRangeCP,
  dateRangeDetention: state.filter.dateRangeDetention,
  dateRangeFGS: state.filter.dateRangeFGS,
});
const mapDispatchToProps = (dispatch) => ({
  dateRangeFilterChange: (newValue) =>
    dispatch({ type: "FILTER_DATERANGE", payload: newValue }),
  DateRangeFilterForRapidResponseActions: (newValue) =>
    dispatch({ type: "RAPID_RESPONSE_FILTER_DATERANGE", payload: newValue }),
  DateRangeFilterCPActions: (newValue) =>
    dispatch({ type: "CP_DATERANGE", payload: newValue }),
  DateRangeFilterDIPActions: (newValue) =>
    dispatch({ type: "DIP_DATERANGE", payload: newValue }),
  DateRangeFilterDetentionActions: (newValue) =>
    dispatch({ type: "SET_DETENTION_DATERANGE", payload: newValue }),
  DateRangeFilterFGSAction: (newValue) =>
    dispatch({ type: "FGS_DATERANGE", payload: newValue }),
});
export default connect(mapStateToProps, mapDispatchToProps)(TabsContent);
